<template>
  <div class="compayn_dashboard"
       style="height:100%;background:#fff;border-raduis:6px;">
    <chartContainer :title="$t('enterprisedashboard.clockStatus')">
      <ZkAreaChart :title="$t('device.online')"
                   :detailTitle="$t('common.details')"
                   @detail="detailEvent('onlineList',$t('device.online')+$t('common.details'))"
                   :count="online"
                   icon="zk-icon-shebeiguanli"
                   :chartCla="chart1"
                   class="areaChar_cla"></ZkAreaChart>
      <ZkAreaChart :title="$t('device.offLine')"
                   :detailTitle="$t('common.details')"
                   @detail="detailEvent('offlineList',$t('device.offLine')+$t('common.details'))"
                   :count="offline"
                   icon="zk-icon-shebeiguanli"
                   :chartCla="chart2"
                   class="areaChar_cla"></ZkAreaChart>
    </chartContainer>
    <chartContainer :title="$t('enterprisedashboard.employeeUpdate')">
      <el-select slot="header"
                 class="min_cla"
                 @change="changeData"
                 v-model="condition"
                 :placeholder="$t('common.select')">
        <el-option v-for="item in options"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value"></el-option>
      </el-select>

      <ZkAreaChart :title="$t('user.add')"
                   :detailTitle="$t('common.details')"
                   :count="newAdded"
                   icon="zk-icon-navicon-zhgl"
                   @detail="detailEvent('newAddedList',$t('user.add')+$t('common.details'))"
                   :chartCla="chart3"
                   class="areaChar_cla"></ZkAreaChart>
      <ZkAreaChart :title="$t('user.delete')"
                   :detailTitle="$t('common.details')"
                   :count="terminated"
                   icon="zk-icon-navicon-zhgl"
                   @detail="detailEvent('terminatedList',$t('user.delete')+$t('common.details'))"
                   :chartCla="chart4"
                   class="areaChar_cla"></ZkAreaChart>
    </chartContainer>
    <el-dialog :title="diaTitle"
               :visible.sync="dialogTableVisible"
               @close="close">
      <deviceDetailsList dataType="online"
                         v-if="show==='onlineList'"
                         :curPage="1"
                         :pageSize="10"></deviceDetailsList>
      <deviceDetailsList dataType="offline"
                         v-if="show==='offlineList'"
                         :curPage="1"
                         :pageSize="10"></deviceDetailsList>
      <devemployeeDetail :condition="condition"
                         dataType="newAdde"
                         v-if="show==='newAddedList'"
                         :curPage="1"
                         :pageSize="10"></devemployeeDetail>
      <devemployeeDetail :condition="condition"
                         dataType="terminate"
                         v-if="show==='terminatedList'"
                         :curPage="1"
                         :pageSize="10"></devemployeeDetail>
    </el-dialog>
  </div>
</template>
<script>
import ZkAreaChart from '../../comComponent/areaChart'
import deviceDetailsList from '../../comComponent/deviceDetailsList'
import devemployeeDetail from '../../comComponent/employeeDetail.vue'
import * as dashboardApi from '@/services/enterpriseDashboardApi.js'
import chartContainer from '../../comComponent/chartContainer'
export default {
  data () {
    return {
      diaTitle: '',
      dialogTableVisible: false,
      chart1: {
        backgroundColor: '#00c0ef'
      },
      chart2: {
        backgroundColor: '#00a65a'
      },
      chart3: {
        backgroundColor: '#f39c12'
      },
      chart4: {
        backgroundColor: '#dd4b39'
      },
      options: [
        {
          value: 1,
          label: this.$t('dashboard.dataFormste', { value: '1' })
        },
        {
          value: 7,
          label: this.$t('dashboard.dataFormste', { value: '7' })
        },
        {
          value: 30,
          label: this.$t('dashboard.dataFormste', { value: '30' })
        }
      ],
      condition: 7,
      offline: 0,
      online: 0,
      // onlineList: [],
      // offlineList: [],
      // terminatedList: [],
      // newAddedList: [],
      newAdded: 0,
      terminated: 0,
      show: ''
    }
  },
  mounted () {
    this.getDeviceDashboard()
    this.getEmployeeUpdateTotal()
  },
  components: {
    ZkAreaChart,
    deviceDetailsList,
    devemployeeDetail,
    chartContainer
  },
  methods: {
    close () { },
    changeData () {
      this.getEmployeeUpdateTotal()
    },
    detailEvent (detail, title) {
      this.diaTitle = title
      this.show = detail
      this.dialogTableVisible = true
    },
    getDeviceDashboard () {
      dashboardApi
        .getDevStateTotal()
        .then(data => {
          if (data.code === '00000000') {
            let result = data.payload.results
            this.offline = result.offline
            this.online = result.online
            // this.onlineList = result.onlineList
            // this.offlineList = result.offlineList
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage()
        })
    },
    getEmployeeUpdateTotal () {
      let params = {
        condition: this.condition
      }
      dashboardApi
        .getEmployeeUpdateTotal(params)
        .then(data => {
          if (data.code === '00000000') {
            let result = data.payload.results
            // this.terminatedList = result.terminatedList
            // this.newAddedList = result.newAddedList
            this.newAdded = result.newAdded
            this.terminated = result.terminated
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage()
        })
    }
  }
}
</script>

<style scoped lang="less">
.compayn_dashboard {
  // min-width: 1000px;
  .areaChar_cla {
    width: 50%;
    float: left;
  }
}
/deep/ .el-pager li {
  min-width: 25px;
}
@media screen and(max-width:1024px) {
  .min_cla {
    width: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/dashboard/dashboard.vue